import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@/utils/utils';

const Slider = (props: React.ComponentProps<typeof SliderPrimitive.Root>) => (
  <SliderRoot {...props}>
    <SliderTrack orientation={props.orientation}>
      <SliderRange orientation={props.orientation} />
    </SliderTrack>
    {props.value?.map((value, index) => (
      <SliderThumb key={index} />
    ))}
  </SliderRoot>
);
Slider.displayName = SliderPrimitive.Root.displayName;

const SliderRoot = ({
  className,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) => (
  <SliderPrimitive.Root
    data-slot="slider-root"
    className={cn(
      'relative flex w-full touch-none select-none items-center',
      props.orientation === 'vertical' && 'flex-col h-auto w-auto',
      className
    )}
    {...props}
  />
);
Slider.displayName = SliderPrimitive.Root.displayName;

const SliderTrack = ({
  className,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Track> & {
  orientation?: 'horizontal' | 'vertical';
}) => (
  <SliderPrimitive.Track
    data-slot="slider-track"
    className={cn(
      'relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20',
      props.orientation === 'vertical' && 'w-1.5 h-full',
      className
    )}
    {...props}
  />
);
SliderTrack.displayName = SliderPrimitive.Track.displayName;

const SliderRange = ({
  className,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Range> & {
  orientation?: 'horizontal' | 'vertical';
}) => (
  <SliderPrimitive.Range
    className={cn(
      'absolute h-full bg-primary',
      props.orientation === 'vertical' && 'h-auto w-full',
      className
    )}
    {...props}
  />
);
SliderRange.displayName = SliderPrimitive.Range.displayName;

const SliderThumb = ({
  className,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Thumb>) => (
  <SliderPrimitive.Thumb
    data-slot="slider-thumb"
    className={cn(
      'block size-4 rounded-full border border-primary/50 bg-background shadow-sm transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
      className
    )}
    {...props}
  />
);
SliderThumb.displayName = SliderPrimitive.Thumb.displayName;

export { Slider, SliderRoot, SliderTrack, SliderRange, SliderThumb };
